import { render, staticRenderFns } from "./TablePageWrapper.vue?vue&type=template&id=200f34cc&"
import script from "./TablePageWrapper.vue?vue&type=script&lang=ts&"
export * from "./TablePageWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./TablePageWrapper.vue?vue&type=style&index=0&id=200f34cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports